import { defineStore } from 'pinia'

export default defineStore("nav", {
  state: ()=>({
    items: [],
  }),
  getters: {
  },
  actions: {
  },
});
